
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  DuplicateSupplierParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\DuplicateSupplierParameters.ts

export class DuplicateSupplierParameters {

  // int SupplierId
  public SupplierId: number=0;

  // string UniqueId
  public UniqueId?: string=null;

  // string Motif
  public Motif?: string=null;
}